import { useRef } from 'react';
import { session } from '../../../webrtc/session';
import { Deferred } from '../../../webrtc/utils/deferred';
import { type TransitionFunc } from '../screenshareState.types';
import { ScreenshareTransition } from '../../../features/screenshare/screenshare.types';

export const useChoosingWindowToShare = (
  onTransition: TransitionFunc,
): (() => Promise<void>) => {
  const deferred = useRef(new Deferred<void>());

  return async (): Promise<void> => {
    session
      .startScreenShare()
      // eslint-disable-next-line promise/always-return
      .then(() => {
        deferred.current.resolve();
        void onTransition(ScreenshareTransition.STARTING_STREAM);
      })
      .catch((error) => {
        deferred.current.reject(error);
        void onTransition(ScreenshareTransition.PERMISSIONS_ERROR, {
          errorType: 'PERMISSIONS_ERROR',
        });
      });

    return deferred.current.promise;
  };
};
